<template>
  <layout>
    <rdkm-title>
      {{ $t('Родственные доноры') }}
      <span class="d-flex float-right"> 
        <user-accessible routerName="ExportRelativeDonors">
          <export-modal :organizationId="query.lrOrganizationId"></export-modal>
        </user-accessible>
        <user-accessible v-if="$auth.user().isLr" routerName="DonorsRelativeEdit">
          <router-link tag="span" to="/donorsRelative/add">
            <b-button class="float-right" right size="sm" variant="primary">
              <font-awesome-icon icon="plus" />{{ $t('Добавить') }}
            </b-button>
          </router-link>
        </user-accessible>
      </span>
    </rdkm-title>
    <div class="tile">
      <filter-form
        :lrOrganizationId="filterQuery.lrOrganizationId"
        :tcOrganizationId="filterQuery.tcOrganizationId"
        :externalId="filterQuery.externalId"
        :status="filterQuery.status"
        :operatorId="filterQuery.operatorId"
        :gender="filterQuery.gender"
        :kinship="filterQuery.kinship"
        v-on:reset="$refs.grid.filter(reset)"
        v-on:search="$refs.grid.filter($event, true)"
      >
      </filter-form>
      <rdkm-grid
        ref="grid"
        :state="filterQuery"
        :emptyDataLabel="$t('Отсутствуют доноры')"
        :export="!!filterQuery.patientId"
        :isCheckable="patient && patient.status == 2"
        :export-url="exportUrl"
      >
      <grid-column
          name="idd"
          :title="$t('IDD')"
          width="110"
          cell="edit-cell"
          :url="(row) => `/donorsRelative/${row.id}`"
        ></grid-column>
        <grid-column
          key="kinshipName"
          :title="$t('Родство')"
          width="100"
          name="kinshipNameLocalized"
        ></grid-column>
        <grid-column
          key="lrCode"
          :title="$t('Код РР')"
          width="75"
          name="lrCode"
        ></grid-column>
        <grid-column
          key="genderName"
          :title="$t('Пол')"
          width="85"
          name="genderNameLocalized"
        ></grid-column>
        <grid-column
          key="age"
          :title="$t('Возраст')"
          width="80"
          name="ageLocalized"
        ></grid-column>
        <grid-column
          key="statusName"
          :title="$t('Статус')"
          width="100"
          name="statusNameLocalized"
        ></grid-column>
        <grid-column
          key="statusDate"
          :title="$t('Дата статуса')"
          width="140"
          name="statusDate"
          :format="date => date ? moment(date).format('DD.MM.YYYY') : ''"
        ></grid-column>
        <grid-column
          key="tcCode"
          :title="$t('Код ТЦ')"
          width="99"
          name="tcCode"
        ></grid-column>
        <grid-column
          key="operatorName"
          :title="$t('Координатор')"
          width="175"
          name="operatorName"
        ></grid-column>
        <grid-column
          key="patientInfo"
          :title="$t('Пациент')"
          width="222"
          name="patientInfo"
          :cell="$auth.user().isRdkm ? 'edit-cell' : ''"
          :url="function(row) { return '/patients/' + row.patientId;}"
        ></grid-column>
        <grid-column v-if="$auth.user().isLr" name="DELETE" cell="delete-cell"></grid-column>
      </rdkm-grid>
    </div>
  </layout>
</template>

<style scoped>
.include-deleted {
  padding-top: 3px !important;
  font-size: 16px;
  line-height: 0;
}

input[type='file'] {
  display: none;
}
.custom-file-upload {
  color: #6c757d;
  border-radius: 3px;
  border: 2px solid #6c757d;
  display: inline-block;
  font-size: 12px;
  font-weight: bold;
  padding: 6px 12px;
  margin-left: 10px;
  cursor: pointer;
}
.custom-file-upload:hover {
  color: white;
  background-color: #6c757d;
}

.swal-modal {
  width: 850px !important;
}
</style>

<script>
import ExportModal from './Export';
import FilterForm from './Filter.vue';
import Grid from '../../components/grid/Grid.vue';
import GridColumn from '../../components/grid/GridColumn.vue';
import axios from 'axios';
import Constants from '../../constants';
import { EventBus } from '../../event-bus';
import DonorService from '../../services/donor.service.js';

export default {
  props: ['query'],
  components: {
    'filter-form': FilterForm,
    'export-modal': ExportModal,
    'rdkm-grid': Grid,
    'grid-column': GridColumn,
  },
  data() {
    return {
      file: '',
      patient: null,
      filterQuery: {},
    };
  },
  beforeMount() {
    this.filterQuery = Object.assign({}, this.query);
    if (this.$auth.user().isLr) {
      this.filterQuery.lrOrganizationId = this.$auth.user().currentOrganization.id;
    }
  },
  created() {
    EventBus.$emit('showThrobber');

    const self = this;
    if (this.query.patientId) {
      axios.get('/patients/' + this.query.patientId).then((response) => {
        self.patient = response.data;
        EventBus.$emit('hideThrobber');
      });
    } else {
      EventBus.$emit('hideThrobber');
    }
  },
  computed: {
    exportUrl() {
      return (
        Constants.baseUrl +
        '/donors/ExportSearchResults?patientId=' +
        this.filterQuery.patientId +
        '&ageFrom=' +
        this.filterQuery.ageFrom +
        '&ageTo=' +
        this.filterQuery.ageTo +
        '&coincidence=' +
        this.filterQuery.coincidence +
        '&externalId=' +
        this.filterQuery.externalId
      );
    },
    reset: function() {
      return {
          status: 1,
          operatorId: null,
        };
    },
  },
  methods: {
    handleFileClick(event) {
      if (this.$auth.user().lrId || this.$auth.user().isLr) {
        return;
      }

      if (event) event.preventDefault();
    },
    handleImportFileUpload(event) {
      DonorService.import(this);
    },
    handleDownloadFile() {
      if (this.$auth.user().lrId || this.$auth.user().isLr) {
        window.open(
          Constants.baseUrl + '/donors/Export?userId=' + this.$auth.user().id
        );
      } else if (this.$auth.user().isRdkm) {
        window.open(
          Constants.baseUrl +
            '/donors/Export?userId=' +
            this.$auth.user().id +
            '&organizationId=' +
            this.filterQuery.organizationId
        );
      }
    },
  },
};
</script>
